export default __webpack_public_path__ + "static/media/comment_stack.4d344d69.svg";